import { ICommonState } from '@/interfaces/store';

const state: ICommonState = {
  dropdowns: [],
  dictionaries: {},
  isFirstPage: true,
};

export default state;
